import '../jquery'

export function hideElement(el) {
  el.css({ display: 'none' })
}

export function showElement(el) {
  el.css({ display: '' })
}

export function scrollToTarget(targetId) {
  $('html, body').animate(
    {
      scrollTop: $(targetId).offset().top
    },
    0
  )
}
